import React, { useEffect } from "react";
import { PAErrorComponent } from "lib/PermissionAware";
import { setCurrentPageTitle } from "Login/modules/LoginModule";
import { store } from "store/createStore";

const NotAuthorizedComponent = props => {
  useEffect(() => {
    setTimeout(() => {
      store?.dispatch(
        setCurrentPageTitle({
          from: "admin",
          label: "common:admin_portal",
          secondLabel: "common:not_authorized",
        })
      );
    }, 10);
  }, []);

  return <PAErrorComponent {...props} />;
};

export default () => ({
  path: "not-authorized",
  component: NotAuthorizedComponent,
  childRoutes: [],
});
